module.exports = __webpack_public_path__ + "img/img-3.19fb342f.png";